module.exports = __webpack_public_path__ + "assets/images/sony-logo.49ca2952.jpg";